import FetchServicesCustomErrors from './BaseFetch';
import saveLocalStorage from './LocalStorage';

export function fetchCurrentUser() {
  const endpoint = `${import.meta.env.REACT_APP_API_SERVER}/api/v1/user`;

  return FetchServicesCustomErrors({ endpoint });
}

export const getCurrentUser = saveLocalStorage(fetchCurrentUser, 'userData');
